export default __webpack_public_path__ + "static/media/Component-3–1-dark.4d2f40da.svg";